import 'react-app-polyfill/ie9';
import 'react-app-polyfill/stable';

import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import Main from './Main';
import './helpers/initFA';
// import {Provider} from 'react-redux'
// import store from './'
ReactDOM.render(
  // <Provide store={}>
  <Main>
    <App />
  </Main>
  // </Provide>
  ,
  document.getElementById('main')
);
